<ub-card [variant]="'success'" [rounded]="true" [dividers]="false">
  <h3 title>{{ userField.doc.name }}</h3>
  <div content>
    <ub-simple-list>
      <ub-simple-list-item>
        <ub-label label="Type" text="{{ userField.doc.fieldType }}" i18n-label></ub-label>
      </ub-simple-list-item>
    </ub-simple-list>
    @if (userField.doc.translationInfo) {
      <eas-translation-info-list [translationInfo]="userField.doc.translationInfo">
      </eas-translation-info-list>
    }
  </div>
  <div actions>
    @if (buttons) {
      <eas-buttons-menu [buttons]="buttons"></eas-buttons-menu>
    }
  </div>
</ub-card>
